import { Breadcrumb, BreadcrumbItem, Icon, Icons, Size, Dialog } from 'construct-ui';
import languageModel from '../models/language.model';
import navigationModel from "../models/navigation/navigation.model";
import HeaderLayout from "./header.layout";
import NavigationLayout from "./navigation.layout";
import DownloadManualButton from '../components/user-manual/download-user-manual-button.component';
import loginModel from '../models/login.model';
import ContactUsDialog from "./contactUs.dialog"

export default function HomeLayout() {
  const LICENSE_URL = loginModel.credentials?.eulaURL || '';
  const POLICY_URL = loginModel.credentials?.privacyURL || '';
  let isContactUsDialogOpen = false;

  const openDialog = () => {
    isContactUsDialogOpen = true;
  }

  const closeDialog = () => {
    isContactUsDialogOpen = false;
  }
  return {
    view: function (vnode) {
      let breadcrumbItems = navigationModel.getBreadcrumbData();

      return [
        m("main", {style: {flex: 1}}, [
          m(HeaderLayout),
          m('.d-flex',
            m(NavigationLayout),
            m('.main-container.flex-1.body-is-open[id="main-container"]',
              m('.container-fluid.py-3',
                breadcrumbItems.length > 0 &&
                m('.content-header',
                  m('.row',
                    m('.col.p-0',
                      m('.px-3.px-md-4',
                        m(Breadcrumb, {
                          class: 'mb-3',
                          size: Size.SM,
                          seperator: m(Icon, { name: Icons.CHEVRON_RIGHT }),
                        }, breadcrumbItems.map((menuItem, index) => [
                          m(BreadcrumbItem,
                            index === 0 && m('i.bi', { class: menuItem.icon }),
                            languageModel.getText(menuItem.menuID, menuItem.name)
                          ),
                        ])),
                        m('.position-relative',
                          m('h1.main-title.mb-2', navigationModel.getCurrentMenuTitle()),
                          m(DownloadManualButton, { menu: breadcrumbItems.at(-1) })
                        ),
                      ),
                      m('hr.my-3')
                    )
                  )
                ),
                m('.row',
                  m('.col-12.p-0',
                    m('.px-3.px-md-4.py-2', vnode.children)
                  )
                )
              )
            )
          )]
        ),
        m('footer.text-center.mb-2',
          m('span', "© Samsung Asia Pte Ltd"),
          m('span', " | "),
          m('a[target="_blank"]', {
            href: LICENSE_URL
          }, "Terms of Use"),
          m('span', " | "),
          m('a[target="_blank"]', {
            href: POLICY_URL
          }, "Privacy Policy"),
          m('span', " | "),
          m('button.btn.btn-link.p-0', {
            onclick: () => { openDialog() }
          }, "Contact Us"),
        ),
        isContactUsDialogOpen &&
        m(Dialog, {
          isOpen: isContactUsDialogOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeDialog,
          title: "Contact Us",
          content: m(ContactUsDialog, { onClose: closeDialog }),
          "class": "cui-dialog-xxl",
        }),
      ]
    }
  }

}
